/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { string, shape, arrayOf, bool, func } from "prop-types";
import { transactionStatus } from "pages/transactions/constants";
import GridTable from "pages/_components/GridTable/GridTable";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import { isEmpty } from "lodash";
import Button from "pages/_components/Button";
import { TransactionSign } from "pages/_components/TransactionCard";
import * as i18n from "util/i18n";
import EcheqHeaderTicket from "pages/echeck/components/EcheqHeaderTicket";
import CustomData from "../../../_components/CustomData/CustomData";

const CesionTransactionBody = (props) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {}, idTransaction = "", idTransactionStatus } = transaction;
    const { showMoreData, setShowMoreData } = props;
    const [buttonLabel, setButtonLabel] = useState("echecks.seeMore.button");
    const isPending = idTransactionStatus === transactionStatus.PENDING;

    const handleSeeMoreData = () => {
        setShowMoreData(!showMoreData);
        if (!showMoreData) {
            setButtonLabel("echecks.seeLess.button");
        } else {
            setButtonLabel("echecks.seeMore.button");
        }
    };

    const { isDesktop } = props;
    const {
        beneficiary = props.beneficiary.document,
        beneficiaryName = props.beneficiary.reference,
        address = props.address,
        reference = props.reference,
        referencevalue = props.referencevalue,
        echeqList = props.echeqList,
        cesion = {},
    } = data;
    const { fecha_emision_cesion = null, cesion_id = "" } = cesion;
    const showCesionInfo = idTransaction && !isEmpty(cesion);

    const echeq = echeqList[0];

    return (
        <div className="ticket__body echeq-endorse">
            <>
                <EcheqHeaderTicket
                    estado={echeq.estado}
                    caracter={echeq.cheque_caracter}
                    moneda={echeq.moneda}
                    monto={echeq.monto}
                    id={echeq.cheque_numero}
                    status={idTransactionStatus}
                    isDesktop={isDesktop}
                />
                <div className="view-more-data-button">
                    <div className="ticket__divider inside-ticket__body">
                        <div className="ticket__notch ticket__notch--left"> </div>
                        <div className="ticket__notch ticket__notch--right"> </div>
                    </div>
                    <Button
                        aria-expanded={showMoreData ? "true" : "false"}
                        className="more-button"
                        label={buttonLabel}
                        bsStyle="link"
                        onClick={handleSeeMoreData}
                        image={showMoreData ? "figma/icon/arrow-up.svg" : "figma/icon/arrow-down.svg"}
                    />
                </div>
                <div className={`view-more-data ${showMoreData ? "expand " : "collapse"}`}>
                    <div className="ticket-section">
                        <div
                            style={{
                                display: "block",
                                width: "100%",
                                gridColumn: "1 / -1",
                            }}>
                            <GridTable>
                                <GridTable.Container className="ticket-gap">
                                    <GridTable.Data columnStart={1} rowStart={1}>
                                        <h2>{i18n.get("echecks.emissor", "Emisor")}</h2>
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={1} rowStart={2} alignY="flex-start">
                                        <CustomData
                                            titleText="echeqs.emit.reference.socialdenomination"
                                            titleTextType="I18N"
                                            valueText={echeq.emisor_razon_social}
                                        />
                                    </GridTable.Data>

                                    <GridTable.Data columnStart={1} rowStart={3}>
                                        <CustomData
                                            titleText="echecks.document"
                                            titleTextType="I18N"
                                            valueText={`CUIT ${echeq.emisor_cuit}`}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={1} rowStart={4}>
                                        <CustomData
                                            titleText="echecks.createdRange.label"
                                            titleTextType="I18N"
                                            valueText={echeq.fecha_emision}
                                            valueTextType="DATE"
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={1} rowStart={5}>
                                        <CustomData
                                            titleText="echecks.emit.emision.label"
                                            titleTextType="I18N"
                                            valueText={`····${echeq?.emisor_cbu?.slice(-4)} ${
                                                echeq?.cheque_tipo
                                            } ${i18n.get(`currency.label.${echeq?.emisor_moneda}`)}`}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={1}>
                                        <h2>{i18n.get("echecks.beneficiary")}</h2>
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={2}>
                                        <CustomData
                                            titleText="echeqs.emit.reference.socialdenomination"
                                            titleTextType="I18N"
                                            valueText={echeq.beneficiario_nombre}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={3}>
                                        <CustomData
                                            titleText="echecks.document"
                                            titleTextType="I18N"
                                            valueText={beneficiary}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} rowStart={4}>
                                        <CustomData
                                            titleText="echecks.payedRange.label"
                                            titleTextType="I18N"
                                            valueText={echeq.fecha_pago}
                                            valueTextType="DATE"
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable>
                        </div>{" "}
                        <div className="ticket__divider divider_2 inside-ticket__body">
                            <div className="ticket__notch ticket__notch--left"> </div>
                            <div className="ticket__notch ticket__notch--right"> </div>
                        </div>
                        <div className="aditional-data">
                            <h2>{i18n.get("", "Datos adicionales")}</h2>
                            <CustomData
                                titleText="echecks.echeckConcept"
                                titleTextType="I18N"
                                valueText={`transfer.reasons.${echeq.cheque_concepto}`}
                                valueTextType="I18N"
                            />
                            <CustomData
                                titleText="echecks.cmc7"
                                titleTextType="I18N"
                                valueText={echeq.cmc7}
                                valueTextType="TEXT"
                            />
                            <CustomData
                                titleText="echecks.echeckReference"
                                titleTextType="I18N"
                                valueText={reference}
                                valueTextType="TEXT"
                            />
                            <CustomData titleText="echecks.currency" titleTextType="I18N" valueText={echeq?.moneda} />
                            <CustomData
                                titleText="echecks.echeckType"
                                titleTextType="I18N"
                                valueText={echeq.cheque_tipo}
                                valueTextType="TEXT"
                            />
                            <CustomData
                                titleText="echeq.transaction.check.amount.label"
                                titleTextType="I18N"
                                valueText={echeq.monto}
                                valueTextType={echeq.emisor_moneda}
                            />
                            <CustomData
                                titleText="echeq.request.amount.label"
                                titleTextType="I18N"
                                valueText={echeqList?.length}
                            />

                            <CustomData
                                titleText="echecks.echeckReferenceValue"
                                titleTextType="I18N"
                                valueText={referencevalue}
                                valueTextType="TEXT"
                            />
                            {showCesionInfo && (
                                <>
                                    <CustomData
                                        titleText="echecks.cession.dateTime"
                                        titleTextType="I18N"
                                        valueText={fecha_emision_cesion}
                                        valueTextType="TEXT"
                                    />
                                    <CustomData
                                        titleText="echecks.cession.cessionId"
                                        titleTextType="I18N"
                                        valueText={cesion_id}
                                        valueTextType="TEXT"
                                    />
                                </>
                            )}
                        </div>
                        <TransactionSign
                            isSmall
                            creationTime
                            hasVaucher
                            isDesktop={isDesktop}
                            noDate={isPending}
                            showMoreData={showMoreData}
                        />
                    </div>
                </div>
            </>
        </div>
    );
};

CesionTransactionBody.propTypes = {
    beneficiary: shape({
        reference: string,
        document: string,
    }),
    echeqList: arrayOf(echeqPropTypes),
    address: string,
    referencevalue: string,
    reference: string,
    isDesktop: bool.isRequired,
    showMoreData: bool,
    setShowMoreData: func,
};

CesionTransactionBody.defaultProps = {
    beneficiary: {
        reference: "",
        document: "",
    },
    echeqList: [],
    address: "",
    referencevalue: "",
    reference: "-",
    showMoreData: false,
    setShowMoreData: () => {},
};

export default CesionTransactionBody;
